<template>
  <div v-if="isLoading" class="features-list primary d-flex justify-center">
    <Loading color="white" text="Carregando..." />
  </div>
  <div
    v-else
    class="features-list primary pb-7"
    @mousemove="handleMouse"
    @click="handleMouse"
  >
    <FeaturesHeader :name="user.nome" :isShowSignOut="!!invoices.length" />

    <v-container class="features-container">
      <v-row v-if="invoices.length" class="mx-4 mt-5">
        <v-col
          cols="12"
          sm="6"
          md="4"
          xl="3"
          class="px-6"
          v-for="item in invoices"
          :key="item.id"
        >
          <Featurer
            :item="item"
            @select="toggleSelect"
            @dialogInformation="handleOpenDialogInformation"
          />
        </v-col>
      </v-row>
      <div v-else-if="!isLoadDocuments" class="invoices-empty">
        <h1 class="white--text mb-7 text-center">Nenhuma fatura pendente.</h1>

        <div class="btn-signout">
          <v-btn
            class="py-6 mt-6 payment-button"
            color="white"
            block
            @click="userLogout"
            @click.right="userLogout"
          >
            <v-icon left light color="black" size="25" class="mr-2"
              >mdi-exit-to-app</v-icon
            >
            Encerrar sessão
          </v-btn>
        </div>
      </div>
    </v-container>

    <BottomCard
      :active="isItemsSelected"
      @deselect="deselectAll"
      :handleEmailSending="handleEmailSending"
      :handleSMSSending="handleSMSSending"
      :handlePrintInvoice="handlePrintInvoice"
      :handlePaymentCard="handlePaymentCard"
    />

    <DialogInformation
      v-if="isOpenDialogInformation"
      :openDialog="isOpenDialogInformation"
      @close="handleCloseOpenDialogInformation"
    />
  </div>
</template>

<script>
import FeaturesHeader from "@/components/FeaturesHeader";
import Featurer from "@/components/Featurer";
import BottomCard from "@/components/BottomCard";
import Loading from "@/components/Loading/Loading";

import { formatNumberReal } from "@/services/formatNumber.service";
import { getMonthAndYear, getDateToPT } from "@/services/date.service";

import userStore from "@/store/user.store";
import adminStore from "@/store/admin.store";
import invoicesStore from "@/store/invoices.store";
import appStore from "@/store/app.store";
import closePageInvoices from "@/store/closePageInvoices.store";

import { signOut } from "@/controllers/user.controller";

import axios from "axios";

import config from "@/config";

import DialogInformation from "@/components/DialogInformation";

export default {
  components: {
    FeaturesHeader,
    Featurer,
    BottomCard,
    Loading,
    DialogInformation,
  },
  data() {
    return {
      isLoading: true,
      isOpenDialogInformation: false,
      isLoadDocuments: false,
      invoices: [],
      selectedInvoices: [],
      formatNumberReal,
      getMonthAndYear,
      getDateToPT,
      userStore,
      user: {},
      handleSetTimeout: "",
      time: 240000,
    };
  },
  computed: {
    userName() {
      return this.user.nome.split(" ")[0];
    },
    isItemsSelected() {
      const items = this.invoices.filter((item) => item.selected);
      if (items && this.invoices.length > 0) {
        return items.length;
      }
      return null;
    },
    isToClosePage() {
      return closePageInvoices.getters.isToClose;
    },
     isDownloadedDocument (){
       return appStore.getters.isDownloadedDocumentRBX
    }
  },
  watch: {
    isToClosePage: function () {
      clearTimeout(this.handleSetTimeout);
      this.handleSetTimeout = setTimeout(
        this.handleSetTimeoutOutput,
        this.time
      );
    },
    isDownloadedDocument: async function (){
      this.isLoadDocuments = true;
      this.invoices = [];
      await this.loadDocuments(this.user.codigo);

    }
  },
  methods: {
    userLogout() {
      clearTimeout(this.handleSetTimeout);
      signOut();
    },
    handleMouse() {
      clearTimeout(this.handleSetTimeout);
      this.handleSetTimeout = setTimeout(
        this.handleSetTimeoutOutput,
        this.time
      );
    },
    handleSetTimeoutOutput() {
      this.userLogout();
    },
    toggleSelect(data) {
      this.invoices.map((item, index) => {
        if (item.id === data.id) {
          let newValue = data;
          newValue.selected = !newValue.selected;
          this.$set(this.invoices, index, newValue);
        }
      });
    },
    deselectAll() {
      this.invoices.forEach((item) => {
        if (item.selected) {
          item.selected = false;
        }
      });
    },
    handleOpenDialogInformation() {
      this.isOpenDialogInformation = true;
      this.handleClearSetTimeout();
    },
    handleCloseOpenDialogInformation() {
      this.deselectAll();

      this.isOpenDialogInformation = false;
    },
    getInvoices() {
      const invoices = this.invoices.filter((invoice) => invoice.selected);
      invoicesStore.commit("setInvoices", invoices);
    },
    handleClearSetTimeout() {
      setTimeout(() => {
        clearTimeout(this.handleSetTimeout);
      }, 2000);
    },
    handleGetInvoicesAndClearSetTimeout() {
      this.getInvoices();
      this.handleClearSetTimeout();
    },
    handlePrintInvoice() {
      this.handleGetInvoicesAndClearSetTimeout()
    },
    handlePaymentCard() {
      this.handleGetInvoicesAndClearSetTimeout()
    },
    handleEmailSending() {
     this.handleGetInvoicesAndClearSetTimeout()
    },
    handleSMSSending() {
     this.handleGetInvoicesAndClearSetTimeout()
    },
    loadDocuments(userCode) {
      axios
        .post(`${config.urlApiTely}/telyNewApi/get_unpaid_document`, {
          customer_id: Number(userCode),
          account_number: 3,
        })
        .then((res) => {
          if (res.data.status === 0) {
            this.isLoading = false;
            return;
          }
       
          res.data.result.forEach((res) => {
            this.invoices.push({ ...res, selected: false });
          });
         
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error(error);
        });
    },
  },
  mounted() {
    this.handleMouse();
  },
  beforeMount() {
    const { id } = adminStore.getters.admin;
    this.user = userStore.getters.user;

    if (!id && !this.user.codigo) {
      this.$router.push("/signinadmin");
    }
   
    if (this.user.codigo) {
      this.loadDocuments(this.user.codigo);
    }
  },
  beforeDestroy() {
    clearTimeout(this.handleSetTimeout);
  },
};
</script>

<style scoped>
.features-list {
  min-height: 100vh;
  position: relative;
  background-image: url('../../assets/background.png');
}
.features-container {
  padding-bottom: 290px;
}
.invoices-empty {
  padding-top: 290px;
}
.btn-signout {
  display: flex;
  justify-content: center;
  justify-items: center;
  width: 70%;
  margin: 0 auto;
}
.payment-button {
  box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.4),
    0px 6px 16px rgba(35, 41, 46, 0.2) !important;
  border-radius: 16px !important;
  font-weight: 600 !important;
  font-size: 17px !important;
}
</style>

